import { nanoid } from "nanoid";
import { setState, state, STATES } from "..";
import { APP_CONFIG } from "../../config";
import { logException } from "../../utils/sentry";
import { LoggedError } from "./state";

function ReportError(
  stateName: STATES,
  event: Error,
  effect: string
) {
  const uuid = nanoid();
  const loggedError: LoggedError = {
    uuid,
    name: event?.name ?? "Error",
    message: event?.message ?? "Unknown error",
    stack: event?.stack,
  };

  setState(
    "ERROR",
    {
      ERROR: {
        ...state.ERROR,
        latestEventTime: new Date().getTime(),
        latestErrorUUID: uuid,
        stateName: stateName,
        errors: [...state.ERROR.errors, loggedError],
      },
    },
    effect
  );
  logException(
    event,
    "USER",
    APP_CONFIG.environment === "staging" ||
    APP_CONFIG.environment === "production",
    state.DEVICE
  );
}
export { ReportError };
